import {
	OptimizelyBoolean,
	OptimizelyLongString,
	OptimizelyXhtmlString,
} from '../index';
import { OptimizelyBlockExpandedValue } from '../expanded';

export interface EasyStepsBlockValue extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'EasyStepsBlock'];
}

export interface ExpandedEasyStepBlock extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'EasyStepBlock'];
	title: OptimizelyLongString;
	text: OptimizelyXhtmlString;
	appStoreUrl?: OptimizelyLongString;
	googlePlayUrl?: OptimizelyLongString;
	displayDownloadUrls?: OptimizelyBoolean;
	backgroundColor: OptimizelyLongString;
	fontColor: OptimizelyLongString;
	downloadAppFromAppstoreLabel: OptimizelyLongString;
	downloadAppFromGooglePlayLabel: OptimizelyLongString;
}

export interface ExpandedEasyStepsRowBlock
	extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'EasyStepRowBlock'];
	rowTitle: OptimizelyLongString;
	downloadAppFromAppstoreLabel: string;
	downloadAppFromGooglePlayLabel: string;
	steps: {
		expandedValue: ExpandedEasyStepBlock[];
		value: Record<string, unknown>[];
	};
}

export interface ExpandedEasyStepsRowBlockWithExpandedSteps
	extends OptimizelyBlockExpandedValue {
	contentType: ['Block', 'EasyStepRowBlock'];
	rowTitle: OptimizelyLongString;
	steps: {
		expandedValue: ExpandedEasyStepBlock[];
	};
}

export interface ExpandedEasyStepsBlock extends EasyStepsBlockValue {
	title: OptimizelyLongString;
	backgroundColor: OptimizelyLongString;
	fontColor: OptimizelyLongString;
	downloadAppFromAppstoreLabel: OptimizelyLongString;
	downloadAppFromGooglePlayLabel: OptimizelyLongString;
	ctaButtonLabel: OptimizelyLongString;
	showCtaButton: OptimizelyBoolean;
	rows: {
		expandedValue: ExpandedEasyStepsRowBlock[];
	};
}

export interface EasyStepBlockProps extends EasyStep {
	index: number;
	downloadAppFromAppstoreLabel: string;
	downloadAppFromGooglePlayLabel: string;
}
export interface ExpandedEasyStepsBlockWithExpandedSteps
	extends EasyStepsBlockValue {
	title: OptimizelyLongString;
	backgroundColor: OptimizelyLongString;
	fontColor: OptimizelyLongString;
	rows: {
		expandedValue: ExpandedEasyStepsRowBlockWithExpandedSteps[];
	};
}

export const isEasyStepsBlock = (
	block: OptimizelyBlockExpandedValue,
): block is EasyStepsBlockValue => {
	return block.contentType[1] === 'EasyStepsBlock';
};

export interface EasyStep {
	title: string;
	text: string;
	appStoreUrl?: string;
	googlePlayUrl?: string;
	displayDownloadUrls?: boolean;
	downloadAppFromAppstoreLabel: string;
	downloadAppFromGooglePlayLabel: string;
}

export interface EasyStepRow {
	rowTitle: string;
	steps?: number;
	contentLink: {
		id: string;
		guidValue: string;
	};
}
export interface EasyStepRowWithSteps {
	rowTitle: string;
	steps: EasyStep[];
}

export interface EasyStepsData {
	title: string;
	backgroundColor: string;
	fontColor: string;
	ctaButtonLabel: string;
	showCTAButton: boolean;
	rows: EasyStepRow[];
	contentLink: {
		id: string;
		guidValue: string;
	};
}
